/*
 * @Author: liuxiuting
 * @Date: 2021-10-20 12:24:53
 * @LastEditors: liuxiuting
 * @LastEditTime: 2025-09-12 11:16:21
 * @FilePath: \carrier\packages\common-mediax\src\common\regs.js
 * @Description:
 *
 * Copyright (c) 2025 by 用户/公司名, All Rights Reserved.
 */
export default {
  numberReg: /^[0-9]+$/, // 校验是否正整数
  phoneReg: /^1[3|4|5|6|7|8|9][0-9]{9}$|^\d{3,4}-\d{7,8}$/, // 验证“手机号”及“区号-固定电话号”
  nameReg: /^[\u4e00-\u9fa5a-zA-Z]+$/, // 仅支持中英文
  accountnumReg: /^[A-Za-z0-9]+$/, // 仅支持英文和数字
  zhname: /^[\u4e00-\u9fa5]+$/, // 仅支持中文
  nameReg1: /^[A-Za-z0-9\u4e00-\u9fa5]+$/, // 仅支持中文、英文和数字
  nameReg2: /^[A-Za-z0-9\u4e00-\u9fa5\.]+$/, // 仅支持中文、英文和数字和.
  // passwordReg: /^[a-zA-Z0-9\u0020-\u002F\u003A-\u0040\u005B-\u0060\u007B-\u007E]{6,32}$/, // 密码长度不低于6,可用英文、数字和标点符号组合，英文区分大小写
  passwordReg: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,32}$/, // 必须包含至少一个大小写和数字,长度为8-32位
  mobilePhReg: /^(1[3-9])\d{9}$/, // 手机号码
  emailReg: '^(\\w)+(\\.\\w+)*@(\\w)+((\\.\\w{2,3}){1,3})$', // 邮箱
  zipcodeReg: /^[1-9]\d{5}$/, // 邮编
  taskname: /^[\u4e00-\u9fa5a-zA-Z0-9\!\@\#\$\%\^\&\*\(\)]{6,}$/, // 中文、英文、数字和特殊字符
  assname: /^[a-zA-Z0-9\!\@\#\.\,\~\_\$\%\^\*\(\)]+$/, // 英文、数字和特殊字符
  url: /^((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?/, // 校验是否是正确网址
  themReg: /^[a-zA-Z0-9\u4e00-\u9fa5\!\@\#\$\%\^\&\*\(\)]+$/, // 中文、英文、数字和特殊字符,不限长度
  domainPath: /^https?:\/\/[\w-]+(\.[\w-]+){2,}(\/[\w-]+)*$/, // http或https的域名+路径
  pathName: /^[\w-]+$/, // 目录名
  urlI: /^((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?/i, // 校验是否是正确网址(不区分大小写)
  videoAccept: ".dv,.swf,.mxf,.m4v,.ogg,.webm,.asf,.avi,.flv,.mp4,.rm,.mov,.mpg,.ts,.3gp,.mkv,.wmv,.rmvb,.mts", // 视频格式
  videoAcceptUrlRegs: /^(https?:\/\/)?((([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})|(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))(:\d+)?(\/[^\s]*)+\.(dv|swf|mxf|m4v|ogg|webm|asf|avi|flv|mp4|rm|mov|mpg|ts|3gp|mkv|wmv|rmvb|mts)(\?[^\s]*)?$/i, // 校验视频链接格式
  videoAcceptRegs: /\.(dv|swf|mxf|m4v|ogg|webm|asf|avi|flv|mp4|rm|mov|mpg|ts|3gp|mkv|wmv|rmvb|mts)$/i, // 校验视频格式
  audioAccept: ".mp3,.ogg,.flac,.wav,.wma,.m4a,.aac",// 音频格式
  audioAcceptRegs: /\.(mp3|ogg|flac|wav|wma|m4a|aac)$/i, // 校验音频格式
  audioAcceptUrlRegs:  /^(https?:\/\/)?((([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})|(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))(:\d+)?(\/[^\s]*)+\.(mp3|ogg|flac|wav|wma|m4a|aac)(\?[^\s]*)?$/i,
  imageAccept: ".jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff,.webp,.psd",
  imageAcceptRegs: /\.(jpg|jpeg|png|gif|bmp|tif|tiff|webp|psd)$/i,
  imageAcceptUrlRegs: /^(https?:\/\/)?((([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})|(\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}))(:\d+)?(\/[^\s]*)+\.(jpg|jpeg|png|gif|bmp|tif|tiff|webp)(\?[^\s]*)?$/i,
  docAccept: ".pdf,.doc,.docx,.wps,.txt,.xls,.xlsx,.csv,.et,.ppt,.pptx,.dps,.jyxproj,.jym,.prproj,.zip,.rar,.7z",
  docAcceptRegs: /\.(pdf|doc|docx|wps|txt|xls|xlsx|csv|et|ppt|pptx|dps|jyxproj|jym|prproj|zip|rar|7z)$/i,
  urlAndUniRegs: /^(((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?)|(#unimp.*)$/, // 校验网址或uni小程序格式
  urlAPPUniRegs: /^(((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?)|(#unimp.*)|([a-zA-Z]+:\/\/.*)$/, // 校验网址或uni小程序格式或者客户端协议
}
